import fontSize from '../fontSize';
import fontWeight from '../fontWeight';
import fontFamily from '../fontFamily';
import lineHeight from '../lineHeight';
export default {
  size: fontSize,
  family: fontFamily,
  weight: fontWeight,
  lineHeight: lineHeight
};